import { apiRequest } from '@/services/api/apiClient.js';

/**
 * A ponte com a API do hdocs.
 *
 * Um lugar so decide o `client` e o prefixo `/api`. Os demais arquivos desta
 * pasta sao listas de endpoint -- URL, metodo, parametros -- e nada mais:
 * nenhum deles conhece Pinia, i18n ou o router.
 *
 * `window.API_HDOCS` e criado no boot, por `config/globalProperties.js`, a
 * partir da `URL_API_BASE_HDOCS` que o Laravel expoe em `/config`. Ler a
 * variavel aqui dentro da funcao -- e nao no topo do modulo -- importa: o
 * modulo e avaliado antes do boot terminar, e um `const` no topo congelaria
 * `undefined`.
 */
export function hdocs({ method = 'get', url, params = {}, body = {}, headers = {}, responseType }) {
    return apiRequest({
        client: window.API_HDOCS,
        method,
        url: `/api${url}`,
        params,
        body,
        headers,
        responseType,
    });
}
